/**
 * Activity Logs Service (Web)
 * 
 * Chức năng: Service để gọi API liên quan đến activity logs cho web app
 */
import { apiService } from './api.service';

export interface ActivityLog {
  id: number;
  userId: number | null;
  user: {
    id: number;
    fullName: string;
    email: string;
    employeeCode?: string;
    avatar?: string | null;
  } | null;
  action: string;
  ip: string | null;
  userAgent: string | null;
  details: any;
  resourceType: 'user' | 'department' | 'company' | 'other';
  resourceId: number | null;
  result: 'success' | 'failure' | 'warning';
  errorMessage: string | null;
  createdAt: string;
}

export interface ActivityLogsResponse {
  data: ActivityLog[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface ActivityLogsFilters {
  userId?: number;
  action?: string;
  resourceType?: 'user' | 'department' | 'company' | 'other';
  result?: 'success' | 'failure' | 'warning';
  startDate?: string;
  endDate?: string;
  status?: 'success' | 'failed';
  userSearch?: string;
  page?: number;
  limit?: number;
}

class ActivityLogsService {
  /**
   * Lấy danh sách activity logs với filters và pagination
   */
  async getActivityLogs(filters: ActivityLogsFilters = {}): Promise<ActivityLogsResponse> {
    const params = new URLSearchParams();
    
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.userId) params.append('userId', filters.userId.toString());
    if (filters.action) params.append('action', filters.action);
    if (filters.resourceType) params.append('resourceType', filters.resourceType);
    if (filters.result) params.append('result', filters.result);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.status) params.append('status', filters.status);
    if (filters.userSearch) params.append('userSearch', filters.userSearch);

    const queryString = params.toString();
    const url = `/activity-logs${queryString ? `?${queryString}` : ''}`;
    
    return await apiService.get<ActivityLogsResponse>(url);
  }

  /**
   * Lấy thống kê tổng từ toàn bộ activity logs (không có filter)
   */
  async getStats(): Promise<{
    total: number;
    success: number;
    failure: number;
    warning: number;
    login: number;
  }> {
    return await apiService.get('/activity-logs/stats');
  }
}

export const activityLogsService = new ActivityLogsService();

